'use strict';

/**
 * Shared-bundle internal entry for Voyado analytics. Theme/page bundles must import
 * event name constants from shared/js/voyadoEventNames instead.
 */
import voyadoAnalytics from './analytics/voyado';

export { loadAnalytics } from './analytics/voyado';
export {
    VOYADO_EVENT_MONITOR_CART,
    VOYADO_EVENT_MONITOR_EMPTY_CART,
    VOYADO_EVENT_TRACK_PRODUCT_IMPRESSION,
    VOYADO_SCRIPT_LOADED,
    VOYADO_INITIALIZE
} from './voyadoEventNames';

export default voyadoAnalytics;
